module.exports = __webpack_public_path__ + "static/media/plantilla-importar.e548221f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plantilla-importar.csv
// module id = ./src/assets/plantilla-importar.csv
// module chunks = 11